import deepmerge from 'deepmerge';
import { baseDomain, environmentCustom } from './environment.custom';

export const environment = deepmerge(
  {
    production: false,
    defaultTitle: 'The CRM',
    serverDateFormat: 'yyyy-MM-dd',
    serverDateTimeFormat: 'dd.MM.yyyy HH:mm',
    sendToServerDateTimeFormat: "yyyy-MM-dd'T'HH:mm:ssxxx",
    baseEndpoint: `https://backend.${baseDomain}/api/`,
    autoBaseEndpoint: `https://backend.${baseDomain}`,
    baseHost: baseDomain,
    api: {
      requestAutorejectTimeoutMs: 60000,
    },
    sentry: {
      enabled: false,
      dsn: '',
      release: '',
    },
    accounting: {
      host: `https://accounting.${baseDomain}`,
    },
    cabinet: {
      host: `https://cabinet.${baseDomain}`,
    },
    id: {
      host: `https://id.${baseDomain}`,
    },
    bill: {
      host: `https://bill.${baseDomain}`,
    },
    billingApi: {
      host: `https://billing-api.${baseDomain}`,
    },
    billingMarketing: {
      host: `https://billing-marketing.${baseDomain}/`,
    },
    communications: {
      host: `https://communications.${baseDomain}`,
    },
    plainExchange: {
      host: `https://plain-exchange.${baseDomain}`,
      telephonyAppKey: '4681fc16-650a-4831-ba02-1f0b468c6036',
    },
    crm: {
      backend: {
        baseEndpoint: `https://backend.${baseDomain}/api/`,
      },
      frontend: {
        host: `https://crm2.${baseDomain}`,
      },
    },
    corporateIntegrationService: {
      baseEndpoint: `https://corporate-integration-service.${baseDomain}/api/`,
    },
    crm1: {
      host: `https://crm.${baseDomain}`,
    },
    business: {
      host: `https://business.${baseDomain}`,
      api: `https://api-business.${baseDomain}/crm2/frontend/v1`,
    },
    customerSupport: {
      host: `https://customer-support.${baseDomain}/`,
    },
    hdi: {
      host: `https://hdi.${baseDomain}/`,
    },
    overbooking: {
      host: `https://overbooking.${baseDomain}`,
    },
    teachersSchedule: {
      baseEndpoint: `https://teachers-schedule.${baseDomain}/api/`,
    },
    c1BusinessManager: {
      host: `https://c1-business-manager.${baseDomain}/`,
    },
    googleApi: {
      oAuthClientId: '557196207486-tiolh1t8n928dkm6bkl94j80gv466qen.apps.googleusercontent.com',
      sheetsApiKey: 'AIzaSyC_JoMnm127CaOZEhvEDDOyqC1Fd3pmdd0',
    },
    tramway: {
      host: `https://tramway.${baseDomain}`,
    },
    trm: {
      host: `https://trm.${baseDomain}`,
    },
    groupLessons: {
      api: `https://grouplessons-api.${baseDomain}/`,
    },
    groupSchedule: {
      baseEndpoint: `https://group-schedule.${baseDomain}/api/`,
    },
    studentVacation: {
      api: `https://student-vacation.${baseDomain}/api/`,
    },
    student: {
      host: `https://student.${baseDomain}/`,
    },
    c1: {
      host: `https://c1.${baseDomain}/`,
    },
    teacher: {
      host: `https://teacher.${baseDomain}/`,
    },
    teachersBusinessRules: {
      api: `https://teachers-business-rules.${baseDomain}`,
    },
    vimbox: {
      host: `https://vimbox.${baseDomain}/`,
    },
    talks: {
      talksPlatformAdminApi: `https://talks-platform.${baseDomain}/admin/api/`,
    },
    tracking: {
      skyengKey: '',
    },
    clientDb: {
      baseEndpoint: `https://client-db.${baseDomain}/api/`,
    },
    corporateBilling: {
      baseEndpoint: `https://corporate-billing.${baseDomain}/api/crm2/frontend/v1/`,
      host: `https://corporate-billing.${baseDomain}`,
    },
    learningGroupsStorage: {
      host: `https://learning-groups-storage.${baseDomain}/`,
    },
    wfm: {
      host: `https://wfm.${baseDomain}`,
    },
    cnBusinessProcess: {
      api: `https://cn-business-process.${baseDomain}/`,
    },
    videoTroubleShooter: {
      host: `https://video-trouble-shooter.${baseDomain}/`,
    },
    redash: {
      host: `https://redash.${baseDomain}/`,
    },
    studyConditionsCoordinator: {
      baseEndpoint: `https://study-conditions-coordinator.${baseDomain}/`,
    },
    timetable: {
      host: `https://timetable.${baseDomain}/`,
    },
    academicGateway: {
      host: `https://academic-gateway.${baseDomain}/`,
    },
    corporateMarketing: {
      host: `https://corporate-marketing-backend.${baseDomain}/`,
    },
  },
  environmentCustom,
);
